import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

/** Representa o Filter da entidade RegiaoGeograficaImediata */
export class RegiaoGeograficaImediataFilter implements Filter {
    idRegiaoGeograficaIntermediaria: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Região Geográfica Intermediária
        if (this.idRegiaoGeograficaIntermediaria) {
            params = params.append('idRegiaoGeograficaIntermediaria', this.idRegiaoGeograficaIntermediaria.toString());
        }

        return params;
    }

    clear() {
        this.idRegiaoGeograficaIntermediaria = null;
    }
}

